/**
 * Constants used throughout the mock interview module
 */

import config from "config";

// Agent ID used for all interview connections
export const MOCK_INTERVIEW_AGENT_ID_DEFAULT = config.mock_interview_agent_id;
export const MOCK_INTERVIEW_AGENT_ID_MALE = config.mock_interview_agent_id_male;

// Version identifier for the participant ID
export const PARTICIPANT_ID_VERSION = "v1";

// session storage key
export const SEARCH_MOCK_INTERVIEW_COMPANY_KEY = "SEARCH_MOCK_INTERVIEW_COMPANY";
export const SEARCH_MOCK_INTERVIEW_ROLE_KEY = "SEARCH_MOCK_INTERVIEW_ROLE";

// Nudge IDs
export const NUDGE_ID_INTERVIEW_PREP_PROFILE_UPDATE = "interview_prep_profile_update";
